import { ClientDTO } from '../../models/Client/ClientDTO';
import AddressesFromClientA from "./DynamicComponet/AddressesFromClientA";

export type AddressesFromClientProps = {
  clientErpId?: string | null;
  client?: ClientDTO | null;
};

export default function AddressesFromClient({ clientErpId, client }: AddressesFromClientProps) {
  if (!clientErpId) return <p>Cliente não selecionado.</p>;

  return (
    <div>

      <AddressesFromClientA
        clientErpId={clientErpId}
        client={client}
      />
    </div>
  );
}
